import { render, staticRenderFns } from "./ArticleVideo.vue?vue&type=template&id=fbcf5dbc&"
import script from "./ArticleVideo.vue?vue&type=script&lang=js&"
export * from "./ArticleVideo.vue?vue&type=script&lang=js&"
import style0 from "./ArticleVideo.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports